import { http } from "../../utils/config";

const productAPI = {
  // Lấy danh sách sản phẩm
  getList: (params = {}) => {
    const {
      page = 1,
      per_page = 15,
      search = '',
      status = '',
      service_category_id = '',
      service_id = '',
      typeId = '',
      mcoupon_branch_id = '',
      sort_by = 'created_at',
      sort_order = 'desc'
    } = params;

    const queryParams = new URLSearchParams({
      page: page.toString(),
      per_page: per_page.toString(),
      sort_by,
      sort_order,
      ...(search && { search }),
      ...(status && { status }),
      ...(service_category_id && { service_category_id: service_category_id.toString() }),
      ...(service_id && { service_id: service_id.toString() }),
      ...(typeId && { typeId }),
      ...(mcoupon_branch_id && { mcoupon_branch_id: mcoupon_branch_id.toString() })
    });

    return http.get(`/api/v1/products?${queryParams}`);
  },

  // Lấy chi tiết sản phẩm
  getById: (id) => {
    return http.get(`/api/v1/products/${id}`);
  },

  // Tạo mới sản phẩm thủ công
  create: (data) => {
    const config = data instanceof FormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
    return http.post('/api/v1/products', data, config);
  },

  // Cập nhật sản phẩm
  update: (id, data) => {
    const config = data instanceof FormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
    // Note: Laravel PUT doesn't work well with Multipart, usually use POST with _method=PUT
    if (data instanceof FormData) {
      data.append('_method', 'PUT');
      return http.post(`/api/v1/products/${id}`, data, config);
    }
    return http.put(`/api/v1/products/${id}`, data, config);
  },

  // Xóa sản phẩm
  delete: (id) => {
    return http.delete(`/api/v1/products/${id}`);
  },

  // Cập nhật tồn kho nhanh
  updateStock: (id, remain_stock) => {
    return http.patch(`/api/v1/products/${id}/stock`, { remain_stock });
  },

  // Bật/tắt trạng thái
  toggleStatus: (id) => {
    return http.patch(`/api/v1/products/${id}/toggle-status`);
  },

  // Bật/tắt hiển thị trên Miniapp
  toggleMiniappDisplay: (id) => {
    return http.patch(`/api/v1/products/${id}/toggle-miniapp`);
  }
};

export const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      if (error.response && error.response.data) {
        throw error.response.data;
      }
      throw new Error(error.message || 'Đã có lỗi xảy ra');
    }
  };
};

export const productAPIWithErrorHandling = {
  getList: withErrorHandling(productAPI.getList),
  getById: withErrorHandling(productAPI.getById),
  create: withErrorHandling(productAPI.create),
  update: withErrorHandling(productAPI.update),
  delete: withErrorHandling(productAPI.delete),
  updateStock: withErrorHandling(productAPI.updateStock),
  toggleStatus: withErrorHandling(productAPI.toggleStatus),
  toggleMiniappDisplay: withErrorHandling(productAPI.toggleMiniappDisplay),
};

export default productAPI;
